import React from 'react';
import { I18nProvider, I18nProviderProps } from '@bingads-webui/copilot-i18n';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { type ILogger } from '@bingads-webui-react/msa-copilot-common';

import { InsightsPanel, InsightPanelProps } from './insights-panel';

type InsightsPanelLoaderProps = InsightPanelProps & {
  i18nProviderProps: Omit<I18nProviderProps, 'bingAdsI18n'>;
  i18n: any;
  logger?: ILogger;
};

/**
 * InsightsPanel will be rendered outside of the <MSAdsCopilot> DOM tree so it won't have automatically get all of the expected context providers.
 * This Loader component will set up any necessary context providers so that InsightsPanel and all its descendants can function correctly.
 *
 * NOTE: Any useContext calls here need to be available in both CMUI and CCUI.
 */
const InsightsPanelLoaderInternal: React.FC<InsightsPanelLoaderProps> = React.memo((props) => {
  const {
    dateFormat,
    dateRange,
    i18nProviderProps,
    onFeedbackButtonClick,
    replyToId,
    TimeZone,
    logger,
    i18n: bingAdsI18n,
  } = props;

  return (
    <I18nProvider bingAdsI18n={bingAdsI18n} {...i18nProviderProps}>
      <InsightsPanel
        dateFormat={dateFormat}
        dateRange={dateRange}
        onFeedbackButtonClick={onFeedbackButtonClick}
        replyToId={replyToId}
        logger={logger}
        TimeZone={TimeZone}
      />
    </I18nProvider>
  );
});

export const InsightsPanelLoader = withI18nConsumer(InsightsPanelLoaderInternal);
